// Link previews (`display_settings` / `link_previews`, Configuración › Pantalla): "false" hides the
// website cards under messages. A message LINK card (permalink) is not a website preview and stays.
let enabled = true;

export function setLinkPreviews(on: boolean): void {
  enabled = on;
}

export function linkPreviewsEnabled(): boolean {
  return enabled;
}
